import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import colors from './colors.json'
import Fonts from './fonts'

export type ThemeColorProps = {
  primary?: boolean | string
  primaryLight?: boolean | string
  secondary?: boolean | string
  accent?: boolean | string
  primaryVariant?: boolean | string
}

export type TypographyProps = {
  light?: boolean | string
  bold?: boolean | string
  medium?: boolean | string
  regular?: boolean | string
  centered?: boolean | string
  left?: boolean | string
  uppercase?: boolean | string
  lowercase?: boolean | string
  underline?: boolean | string
  color?: string
  width?: string
  fontSize?: number | string
  as?: any
} & ThemeColorProps

export type BodyProps = {
  demi?: boolean
}

export type TypographyComponent<T = {}> = FunctionComponent<TypographyProps & T>

export type LabelProps = { small?: boolean | string }

export const textBase = css`
  color: ${colors.background.onColor};
  font-family: ${Fonts.INTER};
`

export const textProps = css`
  ${({ color }: TypographyProps) => color && `color: ${color};`}
  ${({ light }: TypographyProps) => light && `opacity: 0.7;`}
  ${({ fontSize }: TypographyProps) => fontSize && `font-size: ${fontSize};`}
  ${({ regular }: TypographyProps) => regular && `font-weight: ${400};`}
  ${({ medium }: TypographyProps) => medium && `font-weight: ${500};`}
  ${({ bold }: TypographyProps) => bold && `font-weight: ${700};`}
  ${({ accent }: TypographyProps) => accent && `color: white;`}
  ${({ centered }: TypographyProps) => centered && `text-align: center;`}
  ${({ left }: TypographyProps) => left && `text-align: left;`}
  ${({ width }: TypographyProps) => width && `width: ${width}`}
`

export const CustomText: TypographyComponent = styled.p`
  ${textBase}
  ${textProps}
`

/**
 * @fontsize 42px
 */
export const Heading1: TypographyComponent<BodyProps> = styled(CustomText)`
  font-size: 4.2rem;
  line-height: 1.4em;
  font-weight: 700;
  ${textProps}
`

export const Heading2: TypographyComponent<BodyProps> = styled(CustomText)`
  font-size: 1.5rem;
  line-height: 1.4em;
  font-weight: 600;
  color: #333b69;

  ${textProps}
`

export const body1Styles = css`
  font-size: 1.4rem;
  line-height: 1.4em;
  font-weight: 500;
  ${textProps}
`

export const Body1 = styled<any>(CustomText)`
  ${body1Styles}
`

export const Label1: TypographyComponent<BodyProps> = styled(CustomText)`
  font-size: 1.2rem;
  line-height: 1.4em;
  font-weight: 500;
  ${textProps}
`

export const Label2: TypographyComponent<BodyProps> = styled(CustomText)`
  font-size: 0.688rem;
  line-height: 0.813em;
  font-weight: 400;
  letter-spacing: 0em;
  color: #718ebf;
  margin: 0;
  ${textProps}
`

export const BoldText: TypographyComponent<BodyProps> = styled(CustomText)`
  font-size: 1rem;
  line-height: 1.188em;
  font-weight: 600;
  letter-spacing: 0em;
  color: #505887;
  margin: 0;
  ${textProps}
`
export const NavItem: TypographyComponent<BodyProps> = styled(CustomText)`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: inherit;
  //color: #2d60ff;
  margin-left: 20px;
  ${textProps}
`
